import { CheckboxIcon } from "@radix-ui/react-icons";
import { Filter, UserCircle } from "lucide-react";

export const FEATURES = [
  {
    name: "Easy to use.",
    description:
      "With our user-friendly interface, you can discover and share the best scripts with ease.",
    icon: CheckboxIcon,
  },
  {
    name: "Social features.",
    description:
      "Support your favorite creators and stay up to date with their latest scripts.",
    icon: UserCircle,
  },
  {
    name: "Advanced search.",
    description:
      "Filter Roblox scripts by category, popularity, and more to find exactly what you're looking for.",
    icon: Filter,
  },
];
